const STATE = {
  SELECTED: "is-selected",
}
/**
 * Slider Experiences
 */
export default function experiences() {
  const $sliders = document.querySelectorAll('.js-front-page-experiences__slider');

  Array.prototype.forEach.call($sliders, ($slider) => {
    if (Flickity) {
      const flkty = Flickity.data($slider.querySelector('.js-front-page-experiences__slider--data'));
      const $items = $slider.querySelectorAll('.js-front-page-experiences__slider--nav');

      if(flkty) {
        const updateStatusSlider = () => {
          if($items) {
            Array.prototype.forEach.call($items, ($item) => $item.classList.remove(STATE.SELECTED));
            $items[flkty.selectedIndex].classList.add(STATE.SELECTED);
          }
        }
        updateStatusSlider();
  
        flkty.on('select', updateStatusSlider);

        //
        Array.prototype.forEach.call($items, ($item) => {
          $item.addEventListener('click', (event) => {
            event.preventDefault();
            
            const id = event.target.dataset.id;
              
            if(id) {
              flkty.select(id);
              flkty.pausePlayer();
              
            } else {
              console.log('please add data-id="" in your js-team component')
            }
          });
        });
      }
    }
  });
}